import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Axios interceptor to add token to requests
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token && config.url.includes('/api/')) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const api = {
  // Auth API
  login: (username, password) => axios.post(`${API}/auth/login`, { username, password }),
  verifyAuth: (token) => axios.get(`${API}/auth/verify`, {
    headers: { Authorization: `Bearer ${token}` }
  }),

  // Content API
  getAllContent: () => axios.get(`${API}/content`),
  getContentBySection: (section) => axios.get(`${API}/content/${section}`),
  updateContent: (id, data) => axios.put(`${API}/content/${id}`, data),
  createContent: (data) => axios.post(`${API}/content`, data),

  // Services API
  getServices: () => axios.get(`${API}/services`),
  createService: (data) => axios.post(`${API}/services`, data),
  updateService: (id, data) => axios.put(`${API}/services/${id}`, data),
  deleteService: (id) => axios.delete(`${API}/services/${id}`),

  // Projects API
  getProjects: () => axios.get(`${API}/projects`),
  createProject: (data) => axios.post(`${API}/projects`, data),
  updateProject: (id, data) => axios.put(`${API}/projects/${id}`, data),
  deleteProject: (id) => axios.delete(`${API}/projects/${id}`),

  // Upload API
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const token = localStorage.getItem('admin_token');
    return axios.post(`${API}/upload`, formData, {
      headers: {
        'Authorization': `Bearer ${token}`
        // Don't set Content-Type manually - let browser set it with boundary
      }
    });
  },

  // Contact API
  sendContactMessage: (data) => axios.post(`${API}/contact`, data),
  getContactMessages: () => axios.get(`${API}/contact/messages`),
  updateContactMessage: (id, data) => axios.put(`${API}/contact/messages/${id}`, data),
  deleteContactMessage: (id) => axios.delete(`${API}/contact/messages/${id}`),

  // Analytics API
  getAnalyticsStats: () => axios.get(`${API}/analytics/stats`),
  resetAnalytics: () => axios.delete(`${API}/analytics/reset`)
};
